import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';
import { scrollLock } from '../../utils/scrollLock';
/*
 * Description
 * -------
 *
 * Opens and closes modal.
 *
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Targets
 * -------
 *
 * container - (required) - the container element of the modal
 *
 * Values
 * -------
 *
 * open       - (optional) - whether the modal should be open on controller connect
 * cookieName - (optional) - the name of the cookie to set when the modal is closed - modal will be opened only if cookie is not set
 *
 * Usage
 * -------
 *
 * <div data-controller="modal">
 *   <div data-action="click->modal#open"></div>
 *   <div class="hidden" data-modal-target="container">
 *     <div data-action="click->modal#close">Close</div>
 *   </div>
 * </div>
 */
export class Modal extends Controller {
    static targets = ['container'];
    static values = {
        open: { type: Boolean, default: false },
        cookieName: String,
    };
    connect() {
        if (this.openValue)
            this.open();
    }
    close() {
        scrollLock('remove');
        this.containerTarget.classList.add('hidden');
        if (this.cookieNameValue)
            Cookies.set(this.cookieNameValue, 'true', { expires: 7 });
        // On TV session focus element which was focused before modal was opened
        if (this.focusedElement && window.__fw_app__.tvSession)
            this.focusedElement.focus();
    }
    open() {
        scrollLock('add');
        this.containerTarget.classList.remove('hidden');
        // On TV session set current focused element (to be focused after modal is closed)
        // and focus first data-tv-focusable element
        if (window.__fw_app__.tvSession) {
            this.focusedElement = document.activeElement;
            this.containerTarget.querySelector('[data-tv-focusable]')?.focus();
        }
    }
    teardown() {
        this.close();
    }
    documentMorph() {
        this.close();
    }
}
